import { APP_BASE_HREF } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Utils } from '@app/_core/helper/Utils';
import { AppService } from '@app/_core/services/app.service';
import { CampaignService } from '@app/_core/services/campaign.service';
import { WebStorageService } from '@app/_core/services/webstorage.service';
import { FilterDialogComponent } from '@app/pages/common/filter-dialog/filter-dialog.component';
import { ShowHideDialogComponent } from '@app/pages/common/show-hide-dialog/show-hide-dialog.component';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-view-campaign-details',
  templateUrl: './view-campaign-details.component.html',
  styleUrls: ['./view-campaign-details.component.scss'],
})
export class ViewCampaignDetailsComponent implements OnInit {
  constructor(
    private utils: Utils,
    private appService: AppService,
    private campaignService: CampaignService,
    private webStorage: WebStorageService,
    private router: Router,
    private modalService: BsModalService,
    @Inject(APP_BASE_HREF) public baseHref: string
  ) {}
  currentMenu: any = {};
  action = '';
  innerHeight = 60;
  showTable: boolean = true;
  showCrud: boolean = false;
  showDateRange: boolean = false;
  modalRef?: BsModalRef;
  campaignList: any = [];
  dataToDisplay: any = [];
  filteredData: any = [];
  localStorageName = 'CampaignsViewDetails';
  headercount: any = { shown: 0, hidden: 0 };
  selectedCampaignId: any;
  detailsViewData: any;
  filterVal: any;
  selectedFilterByField: any;
  title: any;
  searchField: any = { label: '', value: '' };
  searchValue: any = '';
  filterDict: any = [];
  sortColumn = 'ID';
  sortDescend = true;
  filterOptionRequestColumn = null;
  pl: any = {};
  isMachineDetection: boolean = false;
  cols: any = [
    { name: 'UserID', label: 'UserID', showFilter: true },
    { name: 'CrmUserID', label: 'Crm User ID' },
    { name: 'Name', label: 'Name', showFilter: true },
    { name: 'Company', label: 'Company', showFilter: true },
    { name: 'PhoneNumber', label: 'Phone Number' },
    { name: 'BestCallTimeStart', label: 'Best Call Time Start', type: 'date' },
    { name: 'BestCallTimeEnd', label: 'Best Call Time End', type: 'date' },
    {
      name: 'ActualInteractionTime',
      label: 'Actual Interaction Time',
      type: 'date',
    },
    { name: 'CallsMade', label: 'Calls Made' },
    { name: 'Successes', label: 'Successes' },
    { name: 'Failures', label: 'Failures' },
    { name: 'Responded', label: 'Responded' },
    { name: 'Complete', label: 'Complete' },
    { name: 'ResponseInteractionID', label: 'Response Interaction ID' },
    { name: 'AnsweredBy', label: 'Answered By' },
  ];
  showPagination: boolean = false;

  ngOnInit(): void {
    this.isMachineDetection = this.appService.getIsMachineDetection();
    if(!this.isMachineDetection){
      this.cols = this.cols.filter(item => item.name !== 'AnsweredBy');
    }
    this.appService.selectedCampaignName.subscribe(value => {
      this.title = value;
    });
    this.appService.selectedCampaignId.subscribe(value => {
      this.selectedCampaignId = value;
      this.campaignService.getCampaignDetailsByID(this.selectedCampaignId).subscribe(response => {
        this.filteredData = response.Response.Data;
        this.dataToDisplay = this.filteredData;
        if (this.dataToDisplay.length > 0) this.showPagination = true;
        //this.dataToDisplay = this.detailsViewData;
      });
    });

    this.appService.currentMenu.subscribe((val: boolean) => {
      this.currentMenu = val;
      this.action = this.currentMenu.name;
    });
    this.initializeColumnHeader();
  }

  initializeColumnHeader() {
    const localCol = this.webStorage.getItemFromLocalStorage(this.localStorageName);
    if (localCol != null) {
      this.cols = localCol;
    } else {
      for (const col of this.cols) {
        col.hide = false;
      }
      this.webStorage.setItemInLocalStorage(this.localStorageName, this.cols);
    }
    this.getColumnCount();
  }

  getColumnCount() {
    let shown = 0;
    let hidden = 0;
    for (const header of this.cols) {
      if (header.hide) {
        hidden++;
      } else {
        shown++;
      }
    }
    this.headercount.shown = shown;
    this.headercount.hidden = hidden;
  }

  /*globalFilter*/
  clearSearchBox() {
    this.filterVal = '';
    this.filteredData = this.campaignList;
    this.dataToDisplay = this.applyColumnFilters(this.filteredData);
  }

  applyFilterByField(val) {
    this.selectedFilterByField = val.searchField;
    this.filterVal = val.searchValue;
    if (this.selectedFilterByField.value != '' && this.filterVal != '') {
      this.filteredData = this.findByMatchingProperties(this.campaignList, this.selectedFilterByField, this.filterVal);
      this.dataToDisplay = this.applyColumnFilters(this.filteredData);
    }
  }

  findByMatchingProperties(set: any, properties: any, searchText: string) {
    return set.filter((entry: any) => {
      //alert(typeof(entry[properties.value]))
      if (typeof entry[properties.value] === 'number') {
        if (entry[properties.value].toString() == searchText) {
          return entry;
        }
      } else if (entry[properties.value].toString().includes(searchText)) return entry;
    });
  }

  toggleCustomColumnFilter(colName: string) {
    for (const col of this.cols) {
      if (col.name == colName) {
        if (col.filterVals) {
        } else {
          const unique = [...new Set(this.filteredData.map((item: any) => item[colName]))];
          const filterData: any = [];
          for (const val of unique) {
            filterData.push({ name: val, checked: false });
          }
          col.filterVals = filterData;
        }
      } else {
      }
    }
    this.showColumnFilterModal(colName);
  }

  showColumnFilterModal(colName: string) {
    const initialState = {
      cols: this.cols,
      colName: colName,
    };

    const config: ModalOptions = { class: 'task-menu', backdrop: 'static', initialState };
    this.modalRef = this.modalService.show(FilterDialogComponent, config);
    this.modalRef.content.event.subscribe((result: any) => {
      this.cols = result.data;
      this.dataToDisplay = this.applyColumnFilters(this.filteredData);
    });
  }

  /*column level filter*/
  applyColumnFilters(list: any) {
    //apply column filter here and assign to dataTodisplay
    let records = list;
    for (const colData of this.cols) {
      const filterVals: any = [];
      if (colData.filterVals && colData.filterVals.length > 0) {
        for (const val of colData.filterVals) {
          if (val.checked) {
            filterVals.push(val.name);
          }
        }
        //filterVals
        records = this.filterBySelectedFieldValues(records, colData.name, filterVals);
      }
    }
    return records;
  }

  filterBySelectedFieldValues(set: any, properties: string, searchText: []) {
    if (searchText.length > 0) {
      return set.filter((entry: any) => {
        for (const search of searchText) {
          const fieldValue = entry[properties];
          
          // Handle null/undefined matches
          if (search == null) {
            if (fieldValue == null) {
              return entry;
            }
          } else {
            // Handle non-null values - compare both direct value and string representation
            if (fieldValue != null) {
              const fieldStr = String(fieldValue);
              const searchStr = String(search);
              
              // Direct comparison for numbers or exact matches
              if (fieldValue === search || fieldStr === searchStr) {
                return entry;
              }
            }
          }
        }
      });
    } else {
      return set;
    }
  }

  showHideColumns() {
    const initialState = {
      headerNames: this.cols,
      localStorageName: this.localStorageName,
    };
    const config: ModalOptions = { class: 'task-menu', backdrop: 'static', initialState };
    this.modalRef = this.modalService.show(ShowHideDialogComponent, config);
    this.modalRef.content.event.subscribe((result: any) => {
      this.initializeColumnHeader();
    });
  }

  sortByColumn(colName: string) {
    this.dataToDisplay = this.utils.sortByField(colName, this.cols, this.dataToDisplay);
  }

  onRowSelect(event: any) {
    // this.router.navigateByUrl(this.router.url + '/Details/' + event.data.ID);
  }

  setInnerWidthHeightParameters() {
    this.innerHeight = window.innerHeight * 0.07;
  }

  goBack() {
    let backUrl: any = this.router.url.split('/');
    backUrl.splice(backUrl.length - 2, 2);
    backUrl = backUrl.join('/');
    this.appService.selectedCampaignId.subscribe(value => {
      this.router.navigateByUrl(backUrl + '/Details/' + value);
    });
  }

  clearFilter() {
    this.cols?.forEach((col: any) => {
      delete col.filterVals;
    });
    this.dataToDisplay = this.applyColumnFilters(this.filteredData);
  }
  export(){
    this.pl['campaignID'] = this.selectedCampaignId;
    this.pl['sortColumn'] = this.sortColumn;
    this.pl['filterDict'] = "";
    this.pl['searchValue'] = this.searchValue;
    this.pl['searchField'] = this.searchField.value;
    this.pl['sortDescend'] = this.sortDescend;
    this.pl['filterOptionRequestColumn'] = this.filterOptionRequestColumn;
    this.campaignService.getCampaignDetailsExcel(this.pl).subscribe(res => {
       const src = `data:${res?.MimeType};base64,${res?.result}`;
       const link = document.createElement('a');
       link.href = src;
       link.download = res?.fileName;
       link.click();
       link.remove();
     });
  }
}
